module.exports = __webpack_public_path__ + "img/soto.c1abef4c.webp";